'use client';
import { SwanPathTypeEnum, SwanAssetFolders } from '../types/enums.js';
import { isTestEnv } from './env.utils.js';
import { SWAN_PUBLIC_ASSET_FOLDER, SWAN_VERSIONED_FOLDER, SWAN_HASHED_FOLDER } from '../constants/paths.js';
import { SWAN_BASE_CDN_URL } from '../constants/domains.js';

function getSwanAssetFolderName(e) {
    switch(e){
        case SwanAssetFolders.FAVICONS:
            return 'favicons';
        case SwanAssetFolders.POLYFILLS:
            return 'polyfills';
        case SwanAssetFolders.FONTS:
            return 'fonts';
        case SwanAssetFolders.ICONS:
            return 'icons';
        case SwanAssetFolders.ILLUSTRATIONS:
            return 'illustrations';
        case SwanAssetFolders.IMAGES:
            return 'images';
        case SwanAssetFolders.JS:
            return 'js';
        case SwanAssetFolders.STYLES:
            return 'styles';
    }
}
function getVersionPrefix(e = SwanPathTypeEnum.hashed) {
    return isTestEnv() ? 'pkg-folder-test' : e === SwanPathTypeEnum.versioned ? SWAN_VERSIONED_FOLDER : SWAN_HASHED_FOLDER;
}
function manifestResolve(r, t, n, s = SwanPathTypeEnum.hashed, a = SWAN_BASE_CDN_URL) {
    let l = r[t];
    if (!l) return console.error(`Warning: Invalid style key \`${t}\`: Please remove any deprecated, unsupported, or misspelled style keys from your SwanHead component.`), null;
    let i = l[s] || l.hashed || l.versioned;
    if (i) {
        let e = getVersionPrefix(s), r = getSwanAssetFolderName(n);
        return `${a || ''}${e}/${r}/${i}`;
    }
    return null;
}
function getSameKeyValueMapForManifest(e) {
    return Object.fromEntries(Object.keys(e).map((e)=>[
            e,
            e
        ]));
}
function polyfillResolve(r, n = SWAN_BASE_CDN_URL) {
    let o = getSwanAssetFolderName(SwanAssetFolders.POLYFILLS);
    return `${n}${SWAN_PUBLIC_ASSET_FOLDER}/${o}/${r}`;
}

export { getSameKeyValueMapForManifest, getSwanAssetFolderName, manifestResolve, polyfillResolve };
